import { Link } from "react-router-dom";

const quickCategories = [
  { name: "悬疑", icon: "ri-eye-line", desc: "迷雾与反转" },
  { name: "犯罪", icon: "ri-police-car-line", desc: "追凶与旧案" },
  { name: "剧情", icon: "ri-book-open-line", desc: "人物与时代" },
  { name: "爱情", icon: "ri-heart-3-line", desc: "克制的心动" },
  { name: "古装", icon: "ri-quill-pen-line", desc: "宫廷与笔墨" },
  { name: "喜剧", icon: "ri-emotion-happy-line", desc: "荒诞与日常" },
  { name: "科幻", icon: "ri-planet-line", desc: "时间与深海" },
  { name: "治愈", icon: "ri-hand-heart-line", desc: "慢一点生活" },
];

export default function CategoryQuickLinks() {
  return (
    <section aria-label="分类快捷入口">
      <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-4">
        {quickCategories.map((item) => (
          <Link
            key={item.name}
            to={`/category?genre=${encodeURIComponent(item.name)}`}
            className="group flex items-center gap-3 rounded-lg border border-background-200/90 bg-background-50 p-3 transition-colors hover:border-accent-300 hover:bg-accent-50/60"
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600 transition-colors group-hover:bg-accent-100 group-hover:text-accent-800">
              <i className={`${item.icon} text-base`} />
            </span>
            <span className="flex min-w-0 flex-col">
              <span className="text-[13px] font-medium text-foreground-900">{item.name}</span>
              <span className="truncate text-[10px] text-foreground-500">{item.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}